import { ReturnFilterForm, ReturnSearchForm } from 'types';

export function populateSubmitReturnSearch({
  codes,
  cpf,
  customerName,
}: ReturnSearchForm) {
  return {
    codes: codes || undefined,
    cpf: cpf || undefined,
    customerName: customerName || undefined,
  };
}

export function populateSubmitReturnFilter({
  startDate,
  endDate,
  returnStatuses,
}: ReturnFilterForm) {
  return {
    startDate: startDate || undefined,
    endDate: endDate || undefined,
    returnStatuses: returnStatuses.join(',') || undefined,
  };
}
